<template>
    <div id="deposit-04">
        <div id="processed-popup" class="popup" :class="{ 'is-active': isFinalDepositFlow }">
            <div class="overlay"></div>
            <div class="popup-body d-flex justify-content-center align-items-center pr-4 pl-4">
                <div class="card">
                    <div class="card-body text-center">
                        <div class="img-container text-center mb-4 mt-4">
                        </div>
                        <div class="text-center p-2">
                            <h3 class="font-weight-normal mb-2">
                                ระบบได้เติมเงิน
                                <br />
                                <span class="h6 font-weight-light">เข้าสู่ระบบเรียบร้อยแล้วเป็นจำนวน</span>
                            </h3>
                            <p class="h1 mb-3">{{ request.decimalAmount }}</p>
                            <h6 class="font-weight-light pt-3 m-0">
                                ยอดเงินปัจจุบัน
                            </h6>
                            <p class="h5 font-weight-light text-primary">
                                {{ userWallet.current_money }} บาท
                            </p>
                        </div>
                        <a class="btn btn-primary btn-lg btn-block mt-3" :href="$util.url('member/home')">กลับสู่หน้าหลัก</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="container pr-4 pl-4 pt-3">
            <div class="row">
                <div class="col number-bullet-lg-width-flex">
                    <div class="number-bullet-lg rounded-circle d-flex align-items-center justify-content-center bg-primary-dimmed">
                        <p class="h4 font-weight-normal m-0 text-primary">3</p>
                    </div>
                </div>
                <div class="col pl-0 d-flex align-items-center">
                    <p class="h3 font-weight-normal m-0">ยืนยันการโอนเงิน</p>
                </div>
            </div>
            <div class="row pt-2" v-if="slip.images.length === 0">
                <div class="col text-center">
                    <span class="text-primary m-0">กรุณาโอนเงินยอดนี้ภายใน</span>
                    <div v-if="isPreProcessing" class="spinner-border spinner-border-sm text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span class="h5 text-primary m-0">{{ display.timeLeft }}</span>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-body p-2 text-center">
                            <div v-if="isPreProcessing" class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p class="h3 text-center m-0">
                                {{ request.decimalAmount }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pt-3">
                <div class="col profile-image-width-flex">
                    <img class="profile-image rounded-circle" src="../../../../assets/img/icon_kbank.png" />
                </div>
                <div class="col pl-0 m-auto">
                    <p class="m-0">ชื่อบัญชี บจก.บีเค รีพอร์ต ออนไลน์.</p>
                    <p class="m-0">
                        เลขที่บัญชี &nbsp;
                        <input type="text" value="110-3-66411-6" readonly @click="accountNumberSelect($event)">
                    </p>
                </div>
            </div>
            <!-- <div class="row pt-4">
                <div class="col number-bullet-xl-width-flex">
                    <div class="number-bullet-xl rounded-circle d-flex align-items-center justify-content-center bg-danger-dimmed">
                        <p class="h3 font-weight-normal m-0 text-danger">!</p>
                    </div>
                </div>
                <div class="col pl-0 d-flex align-items-center">
                    <p class="text-danger m-0">
                        โปรดโอนเงินตามยอดทศนิยมระบบจะตรวจสอบยอดของท่านจากเศษทศนิยม และอัพเดทยอดเงินในบัญชีของท่านใน 30 นาที
                    </p>
                </div>
            </div> -->
        </div>
        <div class="container px-4 pt-4">
            <h4>ส่งสลิปยืนยันการโอนเงิน</h4>
            <template v-if="slip.images.length === 0">
                <ImageUploader objectKey="slipImage" v-model="slip.images" :api="$api.deposit.uploadSlip" :extraParam="request.requestId" :onDone="onUploadDone" :limit="slip.limit"></ImageUploader>
            </template>
            <template v-else>
                <div class="container text-center">
                    <img class="img-fluid" :src="slip.images[0]" style="max-height: 500px;">
                </div>
                <p class="text-center mt-2">ส่งสลิปแล้ว</p>
            </template>
        </div>
        <hr class="mt-4">
        <div v-if="slip.images.length > 0" class="px-4 pb-2">
            <p class="text-center mb-0">กรุณารอพนักงานตรวจสอบภายใน 24 ชั่วโมง</p>
        </div>
        <div class="container px-4 pb-4 pt-2">
            <a v-if="slip.images.length > 0" class="btn btn-primary btn-lg btn-block mt-3" :href="$util.url('member/home')">กลับสู่หน้าหลัก</a>
            <a class="btn btn-light btn-lg btn-block" href="http://nav.cx/6vwdq35" target="_blank">แจ้งปัญหาการโอนเงิน</a>
        </div>
    </div>
</template>

<script>
import ImageUploader from '../../sub_components/ImageUploader'

export default {
    data: () => ({
        isPreProcessing: true,
        isProcessing: false,
        isFinalDepositFlow: false,
        userWallet: {
            current_money: 0
        },
        slip: {
            images: [],
            limit: 1,
        },
        interval: {
            countdown: {},
            processedCheck: {}
        },
        display: {
            timeLeft: ''
        },
        request: {
            requestId: '',
            decimalAmount: '',
            expire: ''
        },
    }),
    async created() {
        try {
            const result = await this.$api.deposit.getUserCurrentStep()
            const data = result.data;
            if (data.step !== 'WAIT_PROCESSED')
                this.$router.replace({
                    name: 'deposit-01'
                });
            this.request = result.data.request;

            const slipResult = await this.$api.deposit.getSlip(this.request.requestId);
            if (slipResult.data.success) this.slip.images = [slipResult.data.url];

            if (this.slip.images.length > 0) {
                clearInterval(this.interval.countdown);
            }

            this.isPreProcessing = false;
            // console.log(this.request)
            this.initCountdown();
            // run initial function
            this.timeLeftCalculate();
            this.getProcessStatus();
        } catch (error) {
            console.error(error);
        }
    },
    methods: {
        accountNumberSelect($event) {
            console.log('asd');
            $event.target.focus();
            $event.target.select();
        },
        initCountdown() {
            this.interval.countdown = setInterval(() => {
                this.timeLeftCalculate();
            }, 1000);
            this.interval.processedCheck = setInterval(() => {
                this.getProcessStatus();
            }, 5000);
        },
        timeLeftCalculate() {
            let msLeft = this.$dayjs(`${this.request.expire} +0700`, 'YYYY-MM-DD HH:mm:ss ZZ').utc().diff(this.$dayjs().utc());
            this.display.timeLeft = this.$dayjs(msLeft).utc().format('HH:mm:ss');
            
            if ( msLeft < 0 ) {
                this.$router.replace({
                    name: 'deposit-01'
                });
            }
        },
        async getProcessStatus() {
            this.isProcessing = true;
            try {
                const result = await this.$api.deposit.isProcessed(this.request.requestId)
                const data = result.data;
                if (data.success) {
                    if (data.result) {
                        // processed by staff
                        // TODO: test result again, check new current amount of money
                        await this.getWallet();
                        this.isFinalDepositFlow = true;
                        clearInterval(this.interval.countdown);
                        clearInterval(this.interval.processedCheck);
                    }
                }
                this.isProcessing = false;
            } catch (error) {
                console.error(error);
            }
        },
        async getWallet() {
            const wallet = await this.$api.wallet.get()
            this.userWallet = wallet.data;
        },
        onUploadDone() {
            console.log('upload done');
        },
    },
    beforeDestroy() {
        clearInterval(this.interval.countdown);
        clearInterval(this.interval.processedCheck);
    },
    components: {
        ImageUploader,
    },
};
</script>

<style>

</style>
